<template>
  <!-- 企业上云 -->
  <div class="cloudUpScore">
    <!-- <about></about> -->
    <div class="score-title">评分结果</div>
    <div class="wrap">
      <formLabel class="flb header" name="企业综合评估分数" :value="form1.scores" />
      <formLabel class="flb header" name="“上云”级别" :value="form1.cloudInput" />
    </div>
    <div class="score-title">企业基础信息</div>
    <div class="wrap">
      <formLabel class="flb" name="企业名称" :value="form1.name" />
      <formLabel class="flb" name="企业规模" :value="form1.scale" />
      <formLabel class="flb" name="所在区域" :value="form1.city" />
      <formLabel class="flb" name="所在行业" :value="form1.industry" />
      <formLabel class="flb" name="企业性质" :value="form1.nature" />
      <formLabel class="flb" name="联系人" :value="form1.contact" />
      <formLabel class="flb" name="电话" :value="form1.phone" />
      <formLabel class="flb" name="邮箱" :value="form1.mailbox" />
    </div>
    <div class="score-title">IT资源</div>
    <div class="wrap">
      <formLabel class="flb" name="服务器上云数量" :value="form2.baseService" unit="台" />
      <formLabel class="flb" name="数据库上云数量" :value="form2.baseDatabase" unit="台" />
      <formLabel class="flb" name="存储资源上云数量" :value="form2.baseResource" unit="GB" />
      <formLabel class="flb" name="中间件上云数量" :value="form2.baseDesk" unit="台" />
    </div>
    <div class="score-title">安全防护</div>
    <div class="wrap">
      <formLabel class="flb" name="数据安全上云数量" :value="form2.baseSecData" unit="台" />
      <formLabel class="flb" name="应用安全上云数量" :value="form2.baseSecSystem" unit="台" />
      <formLabel class="flb" name="网络安全上云数量" :value="form2.baseSecNet" unit="台" />
      <formLabel class="flb" name="其他类型基础上云数量" :value="form2.baseOther" unit="台" />
    </div>
    <div class="score-title">办公协同</div>
    <div class="wrap">
      <formLabel class="flb" name="工作文件存储和备份上云数量" :value="form3.oaFile" unit="台" />
      <formLabel class="flb" name="视频会议系统上云数量" :value="form3.oaVideo" unit="台" />
      <formLabel class="flb" name="办公上云数量" :value="form3.oaOffice" unit="台" />
      <formLabel class="flb" name="安保上云数量" :value="form3.oaSecuruty" unit="台" />
    </div>
    <div class="score-title">人力资源管理</div>
    <div class="wrap">
      <formLabel class="flb" name="人力资源基础信息" :value="form3.humanPlan" unit="个" />
      <formLabel class="flb" name="招聘管理数量" :value="form3.humanRecruit" unit="个" />
      <formLabel class="flb" name="培训管理数量" :value="form3.humanTraning" unit="个" />
      <formLabel class="flb" name="绩效管理数量" :value="form3.humanPerformance" unit="个" />
      <formLabel class="flb" name="薪酬管理数量" :value="form3.humanSalary" unit="个" />
      <formLabel class="flb" name="劳动关系管理数量" :value="form3.humanReleation" unit="个" />
    </div>
    <div class="score-title">财务管理</div>
    <div class="wrap">
      <formLabel class="flb" name="税务管理数量" :value="form3.fmTax" unit="个" />
      <formLabel class="flb" name="报销管理数量" :value="form3.fmExpense" unit="个" />
      <formLabel class="flb" name="资产管理数量" :value="form3.fmAssets" unit="个" />
      <formLabel class="flb" name="成本核算管理数量" :value="form3.fmCost" unit="个" />
      <formLabel class="flb" name="资金管理数量" :value="form3.fmMoney" unit="个" />
      <formLabel class="flb" name="总账报表管理" :value="form3.fmTotal" unit="个" />
      <formLabel class="flb" name="其他类型管理使用数量" :value="form3.managerOther" unit="个" />
    </div>
    <div class="score-title">生产</div>
    <div class="wrap">
      <formLabel
        v-if="typeFlag !== '第一产业'"
        class="flb"
        name="研发设计上云数量"
        :value="form4.proDesign"
        unit="个"
      />
      <formLabel class="flb" name="生产管理" :value="form4.proManage" unit="个" />
      <formLabel class="flb" name="质量管理" :value="form4.qualityData" unit="个" />
      <formLabel class="flb" name="生产数据上云数量" :value="form4.proData" unit="个" />
      <formLabel
        v-if="typeFlag == '第二产业'"
        class="flb"
        name="能源管理上云数量"
        :value="form4.proEnergy"
        unit="个"
      />
      <formLabel
        v-if="typeFlag == '第二产业'"
        class="flb"
        name="设备监控上云数量"
        :value="form4.proDevice"
        unit="个"
      />
      <formLabel
        v-if="typeFlag !== '第三产业'"
        class="flb"
        name="产品溯源上云数量"
        :value="form4.proProd"
        unit="个"
      />
      <formLabel
        v-if="typeFlag == '第三产业'"
        class="flb"
        name="服务上云数量"
        :value="form4.proService"
        unit="个"
      />
      <formLabel
        v-if="typeFlag !== '第三产业'"
        class="flb"
        name="安全环保"
        :value="form4.safeEnv"
        unit="个"
      />
    </div>
    <div class="score-title">供应链</div>
    <div class="wrap">
      <formLabel class="flb" name="采购管理上云数量" :value="form4.srmProcure" unit="个" />
      <formLabel class="flb" name="仓储管理上云数量" :value="form4.srmStorage" unit="个" />
      <formLabel class="flb" name="物流管理上云数量" :value="form4.srmFlow" unit="个" />
    </div>
    <div class="score-title">营销</div>
    <div class="wrap">
      <formLabel class="flb" name="销售管理上云数量" :value="form4.marketSale" unit="个" />
      <formLabel class="flb" name="门户网站上云数量" :value="form4.marketPortal" unit="个" />
      <formLabel class="flb" name="电商上云数量" :value="form4.marketShop" unit="个" />
      <formLabel class="flb" name="CRM上云数量" :value="form4.marketCrm" unit="个" />
      <formLabel class="flb" name="客服上云数量" :value="form4.marketCustomer" unit="个" />
    </div>
    <div class="score-title">业务</div>
    <div class="wrap">
      <formLabel class="flb" name="其他上云数量" :value="form4.serviceOther" unit="个" />
    </div>
    <div class="score-title">评级说明</div>
    <rankShow title="A级“上云”建设：" :tipsList="AList"></rankShow>
    <rankShow title="B级“上云”建设：" :tipsList="BList"></rankShow>
    <rankShow title="C级“上云”建设：" :tipsList="CList"></rankShow>
    <rankShow title="D级“上云”建设：" :tipsList="DList"></rankShow>
    <el-button type="primary" class="btn" @click="report">生成报告</el-button>
  </div>
</template>

<script>
import formLabel from "./formLabel.vue";
import rankShow from "./rankShow.vue";
import { getScoreDetail, getCurrentDetail, createPdf } from "@/utils/interface";
// import about from "./component/about.vue";
const form1 = () => {
  return {
    scores: "", //企业综合评估分数
    cloudInput: "", // 上云级别
    name: "", // 企业名称
    scale: "", // 企业规模
    city: "", // 所在区域
    industry: "", // 所在行业
    nature: "", // 企业性质
    contact: "", // 联系人
    phone: "", // 电话
    mailbox: "" // 邮箱
  };
};
const form2 = () => {
  return {
    baseService: "", // 服务器上云数量
    baseDatabase: "", // 数据库上云数量
    baseResource: "", // 存储资源上云数量
    baseDesk: "", // 中间件上云数量
    baseSecData: "", // 数据安全上云数量
    baseSecSystem: "", // 应用安全上云数量
    baseSecNet: "", // 网络安全上云数量
    baseOther: "" // 其他类型基础上云数量
  };
};
const form3 = () => {
  return {
    oaFile: "", // 工作文件存储和备份上云数量
    oaVideo: "", // 视频会议系统上云数量
    oaOffice: "", // 办公上云数量
    oaSecuruty: "", // 安保上云数量
    humanPlan: "", // 人力资源基础信息
    humanRecruit: "", // 招聘管理数量
    humanTraning: "", // 培训管理数量
    humanPerformance: "", // 绩效管理数量
    humanSalary: "", // 薪酬管理数量
    humanReleation: "", // 劳动关系管理数量
    fmTax: "", // 税务管理数量
    fmExpense: "", // 报销管理数量
    fmAssets: "", // 资产管理数量
    fmCost: "", // 成本核算管理数量
    fmMoney: "", // 资金管理数量
    fmTotal: "", // 总账报表管理
    managerOther: "" //其他类型管理使用数量
  };
};
const form4 = () => {
  return {
    proDesign: "", // 研发设计上云数量
    proManage: "", // 生产管理
    qualityData: "", // 质量管理
    proData: "", // 生产数据上云数量
    proEnergy: "", // 能源管理上云数量
    proDevice: "", // 设备监控上云数量
    proProd: "", // 产品溯源上云数量
    proService: "", // 服务上云数量
    safeEnv: "", // 安全环保
    srmProcure: "", // 采购管理上云数量
    srmStorage: "", // 仓储管理上云数量
    srmFlow: "", // 物流管理上云数量
    marketSale: "", // 销售管理上云数量
    marketPortal: "", // 门户网站上云数量
    marketShop: "", // 电商上云数量
    marketCrm: "", // CRM上云数量
    marketCustomer: "", // 客服上云数量
    serviceOther: "" // 其他上云数量
  };
};
export default {
  name: "",
  components: { formLabel, rankShow },
  props: {
    uuid: String
  },
  data() {
    return {
      form1: form1(),
      typeFlag: "", // 所在产业
      form2: form2(),
      form3: form3(),
      form4: form4(),
      AList: [
        {
          label: "资金投入充足、合理，与企业远景发展、战略规划需求的符台性高;"
        },
        {
          label:
            "形成兼具互联网信息化与业务流程管理职能的创新组织形态，成为企业流程变革和模式转型的主要推动者;"
        },
        {
          label:
            "互联网化和信息化战略成为企业战路的重要组成部分，在企业各项业务规划中得到充分落实。"
        }
      ],
      BList: [
        { label: "根据业务发展需求能够合理规划和增大资金投入;" },
        { label: "互联网化和信息化组织参与企业决策;" },
        { label: " 制定企业级专项互联网化和信息化规划。" }
      ],
      CList: [
        { label: "资金投入初步满足企业业务发展需要，适度性较好;" },
        { label: "设置专门的互联网化和信息化组织;" },
        { label: "业务规划制定逐浙考虑互联网技木应用。" }
      ],
      DList: [
        { label: "互联网化和信息化组织建设刚刚起步；" },
        { label: "互联网化和信息化规划没有引起重视。" }
      ]
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.reset();
    if (this.uuid) {
      this.getCurrentDetail(this.uuid);
    } else {
      this.getScoreDetail();
    }
  },
  methods: {
    reset() {
      this.form1 = form1();
      this.form2 = form2();
      this.form3 = form3();
      this.form4 = form4();
    },
    /* 获取当前用户最新一条的上云评分详情 */
    getScoreDetail() {
      this.reset();
      getScoreDetail(this.$store.state.isUsermessage.uuid).then(res => {
        if (res.data && Object.keys(res.data).length > 0) {
          this.form1 = res.data.registerInfo;
          this.form1.scores += " 分";
          this.typeFlag = res.data.registerInfo.typeFlag;
          this.form2 = res.data.infrastructureInfo;
          this.form3 = res.data.managedApplicationsInfo;
          this.form4 = res.data.businessInfo;
        }
      });
    },
    /* 根据uuid获取该条上云评分详情 */
    getCurrentDetail(uuid) {
      getCurrentDetail(uuid).then(res => {
        if (res.data && Object.keys(res.data).length > 0) {
          this.form1 = res.data.registerInfo;
          this.form1.scores += " 分";
          this.typeFlag = res.data.registerInfo.typeFlag;
          this.form2 = res.data.infrastructureInfo;
          this.form3 = res.data.managedApplicationsInfo;
          this.form4 = res.data.businessInfo;
        }
        n;
      });
    },
    report() {
      // 生成报告
      createPdf({ uuid: this.uuid || this.form1.uuid }).then(res => {
        this.downloadBlobFile(res, this.form1.name);
      });
    },
    /* blob二进制文件下载 */
    downloadBlobFile(data, name) {
      const link = document.createElement("a");
      let blob = new Blob([data], { type: `application/pdf` });
      // console.log("type", type, "blob", blob);
      link.style.display = "none";
      link.href = window.URL.createObjectURL(blob);
      let num = "";
      for (let i = 0; i < 10; i++) {
        num += Math.ceil(Math.random() * 10);
      }
      link.setAttribute("download", `${name}上云评分.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.cloudUpScore {
  font-size: 0;
  margin-bottom: 20px;

  .score-title {
    font-size: 16px;
    // font-weight: bold;
    position: relative;
    margin: 20px 0 20px 12px;

    &::before {
      position: absolute;
      content: "";
      width: 4px;
      height: 12px;
      .bc();
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 2px;
    }
  }

  .wrap {
    .header {
      /deep/ .form-value {
        font-size: 28px;
        font-weight: bold;
        color: @basic-colors;
      }
    }

    .flb {
      border-top: none;

      &:nth-of-type(1) {
        border-top: 1px solid #efefef;
      }

      &:nth-of-type(2) {
        border-top: 1px solid #efefef;
      }

      &:nth-of-type(odd) {
        border-right: none;
      }

      &:nth-last-child(1) {
        border-right: 1px solid #efefef;
      }
    }
  }

  .btn {
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/cloudUpScore.vue